// extracted by mini-css-extract-plugin
export default {"tupacGrid":"yn-z","tupacHeader":"zn-z","tupacHeader2":"An-z","tupacMenu":"Bn-z","tupacMenu2":"Cn-z","tupacMain":"Dn-z","tupacMain2":"En-z"};